import React from "react";
import { FaCheck } from "react-icons/fa";

const MultiChoiceQuestion = ({ question, value, onChange }) => {
  const { questionId, options = [], minSelections } = question;
  const selected = Array.isArray(value) ? value : [];

  const toggleOption = (optionValue) => {
    const newSelected = selected.includes(optionValue)
      ? selected.filter((v) => v !== optionValue)
      : [...selected, optionValue];
    onChange(questionId, newSelected);
  };

  return (
    <div>
      {minSelections && (
        <p className="text-xs text-spiders-text-muted mb-2">
          Select at least {minSelections}
        </p>
      )}
      <div className="space-y-2">
        {options.map((option) => {
          const isSelected = selected.includes(option.value);
          return (
            <button
              key={option.value}
              onClick={() => toggleOption(option.value)}
              className={`w-full text-left px-4 py-3 rounded-lg transition-all border ${
                isSelected
                  ? "bg-spiders-primary-500/10 border-spiders-primary-500 text-spiders-text-primary"
                  : "bg-spiders-bg-elevated border-transparent text-spiders-text-secondary hover:bg-spiders-bg-light"
              }`}
            >
              <div className="flex items-center gap-3">
                <div
                  className={`w-4 h-4 rounded border-2 flex items-center justify-center flex-shrink-0 ${
                    isSelected
                      ? "border-spiders-primary-500 bg-spiders-primary-500"
                      : "border-spiders-text-muted"
                  }`}
                >
                  {isSelected && <FaCheck className="w-2.5 h-2.5 text-white" />}
                </div>
                <span className="text-sm">{option.label}</span>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MultiChoiceQuestion;
